import Image from 'next/image';
import React from 'react';
import styled from 'styled-components';
import { WPImageData } from '../../../blocks/model/WPTalentpoolBlock';
import { ButtonSizes, TextButton } from '../../../styles/button';
import { device } from "../../../styles/device";
import StyledLink from '../../global/StyledLink';

const AgenturenContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    column-gap: 10px;
    row-gap: 10px;
    @media ${device.tablet} {
        column-gap: 12px;
        row-gap: 12px;
    }
    @media ${device.laptop} {
        column-gap: 16px;
        row-gap: 16px;
    }
    align-items: center;
    justify-content: center;
    margin-bottom: 64px;
`;

const AgenturImageWrapper = styled.div`
    height: 109px;
    width: 193px;
    position: relative;
    border-radius: 16px;
    background-color: #FFFFFF;
    padding: 12px;

    @media ${device.tablet} {
        height: 150px;
        width: 258px;
        padding: 16px;
    }

    .img-wrapper {
        position: relative;
        height: 100%;
        width: 100%;
        display: flex;
    }
    .link-wrapper {
        width: 100%;

        button {
            margin: auto;
        }
    }
`;

const PostAgenturenList = ({ agenturen }) => {
    return (
        <AgenturenContainer>
            {
                agenturen?.innerBlocks?.map((agenturEdge) => {
                    const agentur = JSON.parse(agenturEdge.attributesJSON);
                    const imageData: WPImageData = agentur?.logo != null ? JSON.parse(decodeURI(agentur.logo)) : null;

                    return (
                        <AgenturImageWrapper key={agentur.name}>
                            <div className='img-wrapper'>
                                <a href={agentur.website} target="_blank" rel="nofollow noopener noreferrer">
                                    <Image
                                        src={imageData.url}
                                        alt={agentur.name + 'Logo Image'}
                                        layout="fill"
                                        objectFit='contain'
                                    />
                                </a>
                            </div>
                            {agentur?.bloglink != null && agentur.bloglink != "" && (
                                <div className='link-wrapper'>
                                    <StyledLink href={agentur.bloglink}>
                                        <TextButton primary size={ButtonSizes.m}>
                                            {"Agenturvorstellung >"}
                                        </TextButton>
                                    </StyledLink>
                                </div>
                            )}
                        </AgenturImageWrapper>
                    );
                })
            }
        </AgenturenContainer>
    )
}

export default PostAgenturenList